import React from 'react';
import { Toaster } from 'react-hot-toast';
import SignupFormCont from './RegisterForm';
import logo from '../../assets/Logo.svg';
import illus from '../../assets/illustration374.svg';
import styles from './Register.module.css';

const Register = () => (
  <>
    <div className={styles.register}>
      <div className={styles['register-card']}>
        <div className={styles.images}>
          <img src={logo} alt="fewcents logo" id={styles['fewcents-logo']} />
          <img
            src="https://images.fewcents.co/branding/fewcents_bridge.jpg"
            alt="fewcents bridge"
            id={styles['illustration-bridge']}
          />
        </div>
        <SignupFormCont />
      </div>
    </div>
    <Toaster
      containerStyle={{
        top: 50,
        left: 20,
        bottom: 20,
        right: 20,
      }}
    />
  </>
);

export default Register;
